import { Heading } from '@chakra-ui/react';
import {
  GetServerSidePropsContext,
  GetServerSidePropsResult,
  NextPage
} from 'next';
import { DynamicImage } from '../../components/Image/Image';
import { Seo } from '../../components/Seo/Seo';
import { BlockManager } from '../../container/BlockManager';
import { fetchAPI } from '../../lib/api';
import { Article, LayoutConfig, StrapiSeo } from '../../types';

interface ArticleProps {
  article: Article;
}

const ArticlePage: NextPage<ArticleProps> = function ({ article }) {
  const seo: StrapiSeo = {
    metaTitle: article.attributes.title,
    metaDescription: article.attributes.teaser,
    shareImage: article.attributes.cover,
    article: true,
  };
  return (
    <>
      <Seo seo={seo} />
      <div className="banner">
        <Heading>{article.attributes.title}</Heading>
      </div>
      <DynamicImage image={article.attributes.cover.data} />
      <div className="mb-6">
        <BlockManager blocks={article.attributes.blocks} />
      </div>
    </>
  );
};

type Data = {
  id: number;
  attributes: { slug: string };
};

type PageProps = GetServerSidePropsContext<{
  slug: string;
}>;



export async function getServerSideProps({
  params,
}: PageProps): Promise<GetServerSidePropsResult<ArticleProps & LayoutConfig>> {
  const [article] = await Promise.all([
    fetchAPI<Article[]>('/articles', {
      filters: {
        slug: params?.slug,
      },
      populate: {
        cover: '*',
        category: '*',
        blocks: {
          populate: '*',
        },
        author: {
          populate: 'picture',
        },
      },
    }),
  ]);

  return {
    props: {
      article: article.data[0],
      layout: {
        showEvents: false,
        containerWidth: 'container.md'
      }
    },

  };
}

export default ArticlePage;
